import React from 'react';
export default /*#__PURE__*/React.createContext({
  clearBreadcrumbItems: () => {
    /* do nothing by default */
  },
  updateBreadcrumbItems: () => {
    /* do nothing by default */
  }
});